import { css } from "@emotion/css"
import React from "react"

type Props = {
  children?: React.ReactNode
}

const SideBarBox = ({ children }: Props) => {
  return (
    <div className={style}>
      <div>{children}</div>
    </div>
  )
}

export default SideBarBox

const style = css`
  border: 1px solid #c3d0d8;
  > div {
    padding: 16px 10px;
    color: #666666;
    border: solid 3px #f2f2f2;
  }
`
